package com.elan.edubridge.shared.domain.usecase

import com.elan.edubridge.shared.domain.model.AttendanceEvent
import com.elan.edubridge.shared.domain.repository.EduConnectRepository
import kotlinx.coroutines.flow.Flow

/**
 * v4 대시보드 실시간 출결 피드.
 *
 * 원본은 append-only 이벤트 로그다 — 파생 프로젝션(`attendanceRecords`)이 아니라 로그를 구독해야
 * 정정(`AMEND`)까지 순서대로 흐른다(§3.5).
 *
 * ⚠️ **Swift는 이 유스케이스를 직접 쓰지 못한다.** `Flow`는 ObjC 헤더로 브리징되지 않으므로
 * iOS는 `AttendanceFeedObserver`를 거친다(`SharedGraph.createAttendanceFeedObserver`).
 */
class ObserveAttendanceFeedUseCase(
    private val repository: EduConnectRepository,
) {
    operator fun invoke(academyId: String, limit: Int): Flow<List<AttendanceEvent>> =
        repository.attendanceEventStream(academyId, limit)
}
